import axios from 'axios';

// NEW (Correct for Nginx):
// This allows the browser to automatically use the domain/IP you are on
const api = axios.create({
    baseURL: '/api' 
});

// --- SECURITY INTERCEPTOR ---
// This code runs before every request.
// It checks if a user is logged in and attaches their "ID Card" (Token)
api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;